
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produto/[marca]/[produto]",
      function () {
        return require("private-next-pages/produto/[marca]/[produto]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produto/[marca]/[produto]"])
      });
    }
  